module.exports = __webpack_public_path__ + "media/post-listing-hero.78bdb718.jpg";